import { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { Menu, X, BookOpen } from "lucide-react";

const links = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/events", label: "Events" },
  { to: "/shop", label: "Shop" },
  { to: "/donate", label: "Donate" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-white/70 border-b border-brand-purple/10">
      <div className="container-wrap flex items-center justify-between py-4">
        <Link to="/" className="flex items-center gap-2.5 group" data-testid="nav-logo-link">
          <span className="w-10 h-10 rounded-full bg-brand-purple flex items-center justify-center text-white shadow-md shadow-brand-purple/30 group-hover:scale-105 transition">
            <BookOpen className="w-5 h-5" />
          </span>
          <span className="flex flex-col leading-tight">
            <span className="font-serif-display text-xl text-brand-dark">WHO DAT Cares</span>
            <span className="text-[10px] tracking-[0.25em] uppercase text-brand-gold font-semibold">Foundation</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-${l.label.toLowerCase()}-link`}
              className={({ isActive }) =>
                `px-4 py-2 rounded-full text-sm font-medium transition ${
                  isActive
                    ? "bg-brand-purple text-white"
                    : "text-brand-dark hover:bg-brand-lavender/60"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link to="/donate" className="btn-primary ml-2 py-2.5 px-5 text-sm" data-testid="nav-donate-cta">
            Give Now
          </Link>
        </nav>

        <button
          className="md:hidden p-2 text-brand-dark"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-menu-button"
          aria-label="Toggle menu"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-brand-purple/10 bg-white/95 backdrop-blur-xl">
          <nav className="container-wrap py-4 flex flex-col gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${l.label.toLowerCase()}-link`}
                className={({ isActive }) =>
                  `px-4 py-3 rounded-lg text-sm font-medium transition ${
                    isActive ? "bg-brand-purple text-white" : "text-brand-dark hover:bg-brand-lavender/60"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}
